module.exports = __webpack_public_path__ + "static/media/end-timer.8d0855f3.svg";